import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 25 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M22.69 1.81a3.638 3.638 0 0 0-5.17.035l-14.5 14.5-1.77 6.905 6.905-1.771 14.5-14.5a3.637 3.637 0 0 0 .035-5.169v0Zm-5.584.45 5.134 5.134m-19.219 8.95 5.139 5.13",
		stroke: "#262626",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2025%2024%22%3E%3Cpath%20d%3D%22M22.69%201.81a3.638%203.638%200%200%200-5.17.035l-14.5%2014.5-1.77%206.905%206.905-1.771%2014.5-14.5a3.637%203.637%200%200%200%20.035-5.169v0Zm-5.584.45%205.134%205.134m-19.219%208.95%205.139%205.13%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
